import { c as _c } from "react/compiler-runtime";
import { GetWishlistsDocument, type GetWishlistsQuery } from '@data-access/lib/gql/wishlists/documents';
import { useGraphQL } from '@data-access/lib/graphql-query';
export const useWishlists = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      select,
      staleTime: 60000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data,
    refetch,
    isLoading
  } = useGraphQL(GetWishlistsDocument, undefined, t0);
  let t1;
  if ($[1] !== data) {
    t1 = data ?? [];
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isLoading || $[4] !== refetch || $[5] !== t1) {
    t2 = {
      wishlists: t1,
      refetchWishlists: refetch,
      isLoading
    };
    $[3] = isLoading;
    $[4] = refetch;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const select = ({
  getWishlists
}: GetWishlistsQuery) => getWishlists;